import { useMemo } from 'react';
import { allCountries } from 'country-telephone-data';

type CountryCode = {
  code: string;
  name: string;
};

export const useCountryPhoneCodes = (): CountryCode[] => {
  const countries = useMemo(() => {
    const seen = new Set<string>();
    const formatted: CountryCode[] = [];

    for (const { dialCode, iso2 } of allCountries) {
      if (!seen.has(dialCode)) {
        seen.add(dialCode);
        formatted.push({ code: dialCode, name: iso2.toUpperCase() });
      }
    }

    formatted.sort((a, b) => parseInt(a.code) - parseInt(b.code));

    return formatted;
  }, []);

  return countries;
};
